import {SUBTITLE1} from '@/utils/constants';
import {Box, Typography} from '@mui/material';
import {PaymentModalStyle} from './PaymentModal.styles';
import PaymentOptions from '../PaymentOptions';
import {currencyFormatter} from '@/utils/helpers/currency';

const PaymentModal = ({
  toPay,
  paymentOption,
  setPaymentOption,
}: {
  toPay: number;
  paymentOption: string;
  setPaymentOption: (value: string) => void;
}) => {
  return (
    <Box sx={{width: '100%'}}>
      <Box sx={PaymentModalStyle.wrapper}>
        <Typography variant={SUBTITLE1}>Total Amount</Typography>
        <Typography variant={SUBTITLE1}>{currencyFormatter.format(toPay)}</Typography>
      </Box>
      <PaymentOptions paymentOption={paymentOption} setPaymentOption={setPaymentOption} />
    </Box>
  );
};

export default PaymentModal;
